/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { getSizesByAdType, AllAdOptions } from '@/lib/ads';
import useScriptFlag from './useScriptFlag';

declare global {
  interface Window {
    googletag: any;
    apstag: any;
    marfeel: any;
    dataLayer: Record<string, any>[];
  }
}

interface UseAdSlotProps {
  adType: AllAdOptions;
  isTransitioning: boolean;
  hash: string;
  isSponsored?: boolean;
}
function useAdSlot({ adType, isTransitioning, hash, isSponsored = undefined }: UseAdSlotProps) {
  const tag = `div-gpt-ad-${adType}-${hash}`;
  const shouldRenderAds = useScriptFlag({ adFlag: 'google' });

  useEffect(() => {
    if (isTransitioning || typeof window === undefined || !shouldRenderAds) {
      return;
    }

    const { googletag, apstag } = window;
    googletag.cmd.push(() => {
      const slotGt = googletag.defineSlot(`/22189562696/${adType}`, getSizesByAdType(adType), `${tag}`).addService(googletag.pubads());

      googletag.display(tag);

      if (adType === 'background/topo-mobile') {
        apstag.fetchBids(
          {
            slots: [
              {
                slotID: tag,
                slotName: `/22189562696/${adType}`,
                sizes: getSizesByAdType(adType),
              },
            ],
          },
          _bids => {
            googletag.cmd.push(() => {
              apstag.setDisplayBids();
              googletag.pubads().refresh([slotGt]);
            });
          }
        );
      } else {
        googletag.pubads().refresh([slotGt]);
      }
    });
  }, [adType, isTransitioning, tag]);

  useEffect(() => {
    if (isSponsored == undefined) return;
    const { googletag } = window;

    const REFRESH_KEY = 'refresh';
    const REFRESH_VALUE = isSponsored ? 'false' : 'true';

    const definedSlotIndex = googletag
      .pubads()
      .getSlots()
      .findIndex(slot => {
        return slot.getAdUnitPath() === `/22189562696/${adType}`;
      });

    definedSlotIndex > -1 && googletag.pubads().getSlots()[definedSlotIndex].setTargeting(REFRESH_KEY, REFRESH_VALUE).setTargeting('refreshed_slot', 'false');
  }, [isSponsored]);
}

export default useAdSlot;
